import * as APP from 'src/api/dev/app'
import * as T from './types'

export default {
    [T.GET_APP_BASE]({ commit }, payload) {
        // 切换应用先清空数据
        commit(T.SET_APP_BASE, {})
        return APP.detail(payload).then(data => {
            commit(T.SET_APP_BASE, data)
            return data
        })
    },

    [T.UPDATE_APP_BASE]({ commit }, payload) {
        return APP.update(payload).then(res => {
            commit(T.UPDATE_APP_BASE, payload)
            return res
        })
    },

    [T.GET_APP_VERSIONS]({ commit }, payload) {
        return APP.getAppVersions(payload).then(data => {
            commit(T.SET_APP_VERSIONS, data)
            return data
        })
    },
    [T.GET_ALL_PUBLISHED_APP_VERSIONS]({ commit }, payload) {
        return APP.getAllAppVersions(payload, 1).then(data => {
            commit(T.SET_ALL_PUBLISHED_APP_VERSIONS, data)
            return data
        })
    },
    [T.GET_ALL_APP_VERSIONS]({ commit }, payload) {
        return APP.getAllAppVersions(payload).then(data => {
            commit(T.SET_ALL_APP_VERSIONS, data)
            return data
        })
    },
    [T.GET_LAST_APP_VERSIONS]({ commit }, payload) {
        return APP.getLastAppVersions(payload).then(data => {
            commit(T.SET_LAST_APP_VERSIONS, data)
            return data
        })
    },
    [T.GET_LAST_ENGINE_VERSIONS]({ commit }, payload) {
        return APP.getLastEngineVersions(payload).then(data => {
            commit(T.SET_LAST_ENGINE_VERSIONS, data)
            return data
        })
    },
    [T.GET_ALL_ENGINE_VERSIONS]({ commit }, payload) {
        return APP.getAllEngineVersions(payload).then(data => {
            commit(T.SET_ALL_ENGINE_VERSIONS, data)
            return data
        })
    },

    [T.CREATE_APP_VERSION](store, {
        webappId, shellVersion, engineVersion, env, version, remark
    }) {
        return APP.createAppVersion(webappId, shellVersion, engineVersion, env, version, remark)
    },

    [T.PUBLISH_APP_VERSION](store, payload) {
        return APP.publishAppVersion(payload.webapp_id, payload.id)
    },

    [T.DELETE_APP_VERSION](store, payload) {
        return APP.deleteAppVersion(payload.webapp_id, payload.id)
    },
    [T.CHECK_APP_VERSION_CAN_DEL](store, payload) {
        return APP.checkVersionCanDelete(payload.webapp_id, payload.id)
    },
    [T.COPY_APP_VERSION](
        store,
        {
            webappId, versionId, shellVersion, engineVersion, env, version, remark
        }
    ) {
        return APP.copyAppVersion(
            webappId,
            versionId,
            shellVersion,
            engineVersion,
            env,
            version,
            remark
        )
    },

    [T.BUILD_APP_VERSION](store, payload) {
        return APP.buildAppVersion(payload.webapp_id, payload.id, 'Webapp')
    },
    [T.BUILD_APP_VERSION_COMPONENT](store, payload) {
        return APP.buildAppVersion(payload.webapp_id, payload.id, 'Component')
    },
    [T.GET_APP_VERSION_BUILDS](store, {
        page = 1, status, webappId, versionId, pageSize
    }) {
        return APP.getAppVersionBuilds(page, status, webappId, versionId, pageSize)
    },
    [T.GET_APP_VERSION_BUILD_STATUS](store, { webappId, versionId, from }) {
        return APP.getAppVersionBuildStatus(webappId, versionId, from)
    },
    [T.ADD_APP_VERSION_COMPONENTS](store, payload) {
        return APP.addAppVersionComponents(payload.webapp_id, payload.id, payload.components, payload.feature_version)
    },
    [T.GET_APP_VERSION_ALL_COMPONENT](store, payload) {
        return APP.getAppVersionAllComponent(payload.webapp_id, payload.id, payload.prevVersionId)
    },
    [T.GET_ALL_COMPONENT_PACKAGES](store, payload) {
        return APP.getAllComponentPackages(payload.webapp_id, payload.prevVersionId)
    },
    [T.GET_APP_VERSION_USED_COMPONENT](store, payload) {
        return APP.getAppVersionUsedComponent(payload.webapp_id, payload.id)
    },
    [T.GET_SYSTEM_COMPONENT](store, { id, previousVersionId }) {
        return APP.getSystemComponent(id, previousVersionId)
    },
    [T.GET_COMPONENT_VERSIONS](store, { componentId, webappId }) {
        return APP.getComponentVersions(componentId, webappId)
    },
    [T.GET_BUILD_LOGS](store, {
        webapp_id: webappId, id, groupId, preLogId, type, limit
    }) {
        return APP.getBuildLogs(webappId, id, groupId, preLogId, type, limit)
    },
    [T.GET_APP_SHELL_VERSION](store, { webappId, env }) {
        return APP.getAppShellVersion(webappId, env)
    },
    [T.GET_ALL_APP_SHELL_VERSION](store, { webappId, env }) {
        return APP.getAllAppShellVersion(webappId, env)
    },
    [T.SAVE_APP_SHELL_VERSION](
        store,
        {
            webappId, env, iosAppstoreUrl, iosReleaseVer, androidApkUrl, androidReleaseVer
        }
    ) {
        return APP.saveAppShellVersion(
            webappId,
            env,
            iosAppstoreUrl,
            iosReleaseVer,
            androidApkUrl,
            androidReleaseVer
        )
    },
    [T.GET_APP_API](store, { webappId, env }) {
        return APP.getAppApi(webappId, env)
    },
    [T.SAVE_APP_API](store, { webappId, env, apis }) {
        return APP.saveAppApi(webappId, env, apis)
    },

    [T.GET_WEBAPP_VARS](store, { webappId, env }) {
        return APP.getWebappVars(webappId, env)
    },
    [T.SET_WEBAPP_VARS](store, { webappId, env, vars }) {
        return APP.setWebappVars(webappId, env, vars)
    },

    [T.GET_TENANT_LIST]({ commit }, payload) {
        return APP.getTenantList(payload).then(res => {
            commit(T.SET_TENANT_LIST, res.items)
            commit(T.SET_TENANT_VERSIONS, res.tenantVersion)
            commit(T.SET_TENANT_UPDATE_VERSIONS, res.updateVersion)
            return res
        })
    },
    [T.GET_TENANT_UPDATE_INFO]({ commit }, payload) {
        return APP.getTenantUpdateInfo(payload).then(res => {
            commit(T.SET_TENANT_UPDATE_INFO, res)
            return res
        })
    },
    // 删除租户
    [T.DELETE_TENANT](store, payload) {
        return APP.deleteTenant(payload)
    },
    // 获取租户日志
    [T.GET_TENANT_LOG](store, payload) {
        return APP.TenantLog(payload)
    },
    [T.UPDATE_TENANT](store, payload) {
        return APP.updateTenant(payload)
    },
    [T.GET_ALI_LOGS](store, payload) {
        return APP.getAliLogs(payload)
    },
    [T.GET_ALI_LOG](store, payload) {
        return APP.getAliLog(payload)
    },

    // 新增模版
    [T.CREATE_TEMPLATE](store, { webappId, versionId, params }) {
        return APP.createNewTemplate(webappId, versionId, params)
    },

    // 获取模版列表
    [T.GET_TEMPLATE_LIST](store, {
        webappId, versionId, page = 1, pageSize = 13
    }) {
        return APP.getTemplateList(webappId, versionId, page, pageSize)
    },

    // 删除模版
    [T.DELETE_TEMPLATE](store, { webappId, versionId, templateId }) {
        return APP.deleteTemplate(webappId, versionId, templateId)
    },

    // 检测模版重名
    [T.CHECK_TEMPLATE_NAME](store, { webappId, versionId, name }) {
        return APP.checkTemplateName(webappId, versionId, name)
    },

    // 编辑模版
    [T.EDIT_TEMPLATE](store, {
        webappId, versionId, templateId, params
    }) {
        return APP.editTemplate(webappId, versionId, templateId, params)
    },

    // 下架模版
    [T.SUBMIT_TEMPLATE](store, {
        webappId, versionId, templateId, params
    }) {
        return APP.submitTemplate(webappId, versionId, templateId, params)
    },

    // 复制模版
    [T.COPY_TEMPLATE](store, {
        webappId, versionId, templateId, params
    }) {
        return APP.copyTemplate(webappId, versionId, templateId, params)
    },

    // 获取服务列表
    [T.GET_SERVICE_LIST](store, { webappId, page, pageSize }) {
        return APP.getServiceList(webappId, page, pageSize)
    },

    // 添加服务
    [T.ADD_SERVICE](store, { webappId, params }) {
        return APP.addService(webappId, params)
    },

    // 编辑服务
    [T.EDIT_SERVICE](store, { webappId, objectId, params }) {
        return APP.editService(webappId, objectId, params)
    },

    // 删除服务
    [T.DELETE_SERVICE](store, { webappId, objectId }) {
        return APP.deleteService(webappId, objectId)
    },

    // 业务对象分组
    [T.GET_NEW_OBJECT_GROUP](store, { webappId }) {
        return APP.getNewObjectGroup(webappId)
    },
    // 新增业务对象分组
    [T.ADD_NEW_OBJECT_GROUP](store, { webappId, params }) {
        return APP.addNewObjectGroup(webappId, params)
    },
    // 编辑业务对象分组
    [T.EDIT_NEW_OBJECT_GROUP](store, { webappId, groupId, params }) {
        return APP.editNewObjectGroup(webappId, groupId, params)
    },
    // 删除业务对象分组
    [T.DEL_NEW_OBJECT_GROUP](store, { webappId, groupId }) {
        return APP.delNewObjectGroup(webappId, groupId)
    },
    
    // 新业务对象
    [T.GET_NEW_OBJECT](store, { webappId, params }) {
        return APP.getNewObject(webappId, params)
    },
    // 新增业务对象
    [T.ADD_NEW_OBJECT](store, { webappId, params }) {
        return APP.addNewObject(webappId, params)
    },
    // 编辑业务对象
    [T.EDIT_NEW_OBJECT](store, { webappId, objectId, params }) {
        return APP.editNewObject(webappId, objectId, params)
    },
    // 删除业务对象
    [T.DEL_NEW_OBJECT](store, { webappId, objectId }) {
        return APP.delNewObject(webappId, objectId)
    },
    // 查询业务对象详情
    [T.GET_NEW_OBJECT_DTL](store, { webappId, objectId }) {
        return APP.getNewObjectDtl(webappId, objectId)
    },

    // 新业务对象字段
    [T.GET_NEW_OBJECT_FIELD](store, { webappId, objectId }) {
        return APP.getNewObjectField(webappId, objectId)
    },
    // 新增业务对象字段
    [T.ADD_NEW_OBJECT_FIELD](store, { webappId, objectId, params }) {
        return APP.addNewObjectField(webappId, objectId, params)
    },
    // 编辑业务对象字段
    [T.EDIT_NEW_OBJECT_FIELD](store, {
        webappId, objectId, fieldId, params
    }) {
        return APP.editNewObjectField(webappId, objectId, fieldId, params)
    },
    // 删除业务对象字段
    [T.DEL_NEW_OBJECT_FIELD](store, { webappId, objectId, fieldId }) {
        return APP.delNewObjectField(webappId, objectId, fieldId)
    },

    // 服务分组
    [T.GET_NEW_SERVICE_GROUP](store, { webappId }) {
        return APP.getNewServiceGroup(webappId)
    },
    // 新增服务分组
    [T.ADD_NEW_SERVICE_GROUP](store, { webappId, params }) {
        return APP.addNewServiceGroup(webappId, params)
    },
    // 编辑服务分组
    [T.EDIT_NEW_SERVICE_GROUP](store, { webappId, groupId, params }) {
        return APP.editNewServiceGroup(webappId, groupId, params)
    },
    // 删除服务分组
    [T.DEL_NEW_SERVICE_GROUP](store, { webappId, groupId }) {
        return APP.delNewServiceGroup(webappId, groupId)
    },
    
    // 新服务
    [T.GET_NEW_SERVICE](store, { webappId, params }) {
        return APP.getNewService(webappId, params)
    },
    // 新增服务
    [T.ADD_NEW_SERVICE](store, { webappId, params }) {
        return APP.addNewService(webappId, params)
    },
    // 编辑服务
    [T.EDIT_NEW_SERVICE](store, { webappId, serviceId, params }) {
        return APP.editNewService(webappId, serviceId, params)
    },
    // 删除服务
    [T.DEL_NEW_SERVICE](store, { webappId, serviceId }) {
        return APP.delNewService(webappId, serviceId)
    },

    // app 更新
    [T.GET_APP_UPGRADE_CONFIG](store, payload) {
        return APP.getAppUpgradeConfig(payload)
    },
    [T.PUT_APP_UPGRADE_CONFIG](store, payload) {
        return APP.putAppUpgradeConfig(payload)
    },
    [T.GET_PARENT_APP_VERSIONS]({ commit }, webappId) {
        return APP.getParentVersions(webappId).then(data => {
            commit(T.SET_PARENT_APP_VERSIONS, data)
            return data
        })
    },
    
    // 获取app版本我的组件列表
    [T.GET_APP_VERSION_MY_COMPONENT_LIST](
        store,
        { webapp_id: webappId, id, prevVersionId }
    ) {
        return APP.getAppVersionMyComponentList(webappId, id, prevVersionId)
    },
    // 获取app版本系统组件列表
    [T.GET_APP_VERSION_SYSTEM_COMPONENT_LIST](
        store,
        { id, prevVersionId }
    ) {
        return APP.getSystemComponentList(id, prevVersionId)
    },
    getAllEngineVersion() {
        return APP.getAllEngineVersions({
            type: 'mobile'
        })
    },
    [T.GET_OBJECT_DETAIL](store, payload) {
        return APP.getObjectDetail(payload).then(data => data)
    }
}
